import { InjectionToken } from '@angular/core';

export const CAPTCHA_REPOSITORY_PORT = new InjectionToken<CaptchaRepositoryPort>('CaptchaRepositoryPort');

export interface CaptchaRepositoryPort {
    execute(action: string): Promise<string>;
    destroy(): void;
}
